import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { env } from '@/env';

/**
 * Same engine as the rest of Nexvia: Firebase client auth, whose ID token this app sends as a
 * Bearer token directly to `nexvia-api-web` (see useAuth.ts) — mirrors
 * nexvia-web-app/src/contexts/FirebaseContext.tsx, not nexvia-backoffice's cookie-exchange
 * flow (backoffice trades the ID token for an HTTP-only session cookie at
 * `/backoffice/auth/firebase`; that is a different, admin-specific mechanism this app does not
 * use, since the depósito account talks to the same customer-facing API surface as the web app).
 *
 * Four config fields, not seven: this app initialises exactly one Firebase service (Auth).
 * storageBucket / messagingSenderId / measurementId configure Cloud Storage, FCM and Analytics —
 * document uploads go through DO Spaces pre-signed URLs instead (spec §2, mirroring
 * driver-document), so those three would be dead weight that reads as an integration that isn't
 * there.
 */
const firebaseConfig = {
  apiKey: env.VITE_APP_FIREBASE_API_KEY,
  authDomain: env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_APP_FIREBASE_PROJECT_ID,
  appId: env.VITE_APP_FIREBASE_APP_ID
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export { firebase };
export default firebase;
